import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateCompanyPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    company_name: "",
    linkedinUrl: "",
    website: "",
    industry: "",
    orgSize: "",
    orgType: "",
    logo: null,
    tagline: "",
    agree: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <div className="bg-[#F3F2EF] mt-14 ">
      <div className="bg-white rounded-lg p-6 w-full mb-6">
        <div className="container mx-auto py-0 gap-4 px-4 sm:px-6 lg:px-8">
          <button
            className="text-blue-600 font-semibold flex items-center"
            onClick={() => navigate(-1)}
          >
            <svg
              className="w-4 h-4 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Back
          </button>
          <div className="flex items-center mt-4">
            <img
              src="/Images/business/company/building-icon.png"
              alt="building"
              className="w-8 h-8 mr-2"
            />
            <h2 className="text-lg font-sm mb-2">
              Let's get started with a few details about your company:
            </h2>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-col lg:flex-row py-0 gap-4 px-4 sm:px-6 lg:px-8">
        <div className="min-h-screen">
          <div className="flex w-full space-x-6">
            {/* Left Section: Form */}
            <div className="bg-white rounded-lg p-6 w-2/3">
              <div className="flex items-center mb-4"></div>
              <p className="text-red-500 text-sm mb-4">*indicates required</p>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Name *
                  </label>
                  <input
                    type="text"
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Add your organization's name"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    linkedin.com/company/*
                  </label>
                  <input
                    type="url"
                    name="linkedinUrl"
                    value={formData.company_name
                      .toLowerCase()
                      .replace(/ /g, "-")}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Add LinkedIn Company URL"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Website *
                  </label>
                  <input
                    type="url"
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Add Website"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Industry *
                  </label>
                  <input
                    type="url"
                    name="industry"
                    value={formData.industry}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Ex: Information Technology"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Organization Size *
                  </label>
                  <select
                    name="orgSize"
                    value={formData.orgSize}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Select Size</option>
                    <option value="1">0-1 employee</option>
                    <option value="1-10">1-10 employees</option>
                    <option value="11-50">11-50 employees</option>
                    <option value="51-200">51-200 employees</option>
                    <option value="201-500">201-500 employees</option>
                    <option value="501-1000">501-1000 employees</option>
                    <option value="1001-5000">1001-5000 employees</option>
                    <option value="5001+">5001-10,000 employees</option>
                    <option value="10000+">10,000+ employees</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Organization Type *
                  </label>
                  <select
                    name="orgType"
                    value={formData.orgType}
                    onChange={handleInputChange}
                    className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Organization type</option>
                    <option value="public">Public Company</option>
                    <option value="nonprofit">Self-employed</option>
                    <option value="government">Government agency</option>
                    <option value="nonprofit">Nonprofit</option>

                    <option value="education">Sole Proprietorship</option>
                    <option value="private">Privately Held</option>
                    <option value="public">Partnership</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Logo *
                  </label>
                  <div className="mt-1 w-full">
                    <label className="flex flex-col items-center px-4 py-6 bg-gray-100 border rounded-md cursor-pointer hover:bg-gray-200">
                      <svg
                        className="w-6 h-6 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                        ></path>
                      </svg>
                      <span className="mt-1 text-sm text-gray-600">
                        Choose file to upload
                      </span>
                      <input
                        type="file"
                        name="logo"
                        onChange={handleInputChange}
                        className="hidden"
                        accept="image/jpeg,image/png"
                        required
                      />
                    </label>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    300 x 300px recommended. JPEG, JPG, and PNG supported.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900">
                    Tagline *
                  </label>
                  <input
                    type="text"
                    name="tagline"
                    value={formData.tagline}
                    onChange={handleInputChange}
                    className="h-[100px] mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Ex: An information technology company helping small business succeed"
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Use your tagline to briefly describe what your organization
                    does. This can be changed later.
                  </p>
                </div>

                <div>
                  <label className="flex items-start text-sm text-gray-700">
                    <input
                      type="checkbox"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleInputChange}
                      className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
                      required
                    />
                    <span>
                      I verify that I am an authorized representative of this
                      organization and have the right to act on its behalf in
                      the creation and management of this page. The organization
                      and I agree to the additional terms for Pages.
                    </span>
                  </label>
                </div>

                <button
                  onClick={handleSubmit}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md w-full hover:bg-blue-700"
                >
                  CREATE PAGE
                </button>
              </div>
            </div>

            {/* Right Section: Preview */}
            <div className="h-[400px] bg-gray-200 rounded-[10px] w-1/3 ">
              <h3 className="text-sm font-medium text-gray-700 p-4 rounded-t-[10px] bg-[#fff]">
                Page preview <span className="text-gray-500">?</span>
              </h3>
              <div className=" rounded-[10px] p-4 m-4 bg-[#fff]">
                <div className="w-24 h-24 bg-[#fff] rounded-lg  mb-2">
                  {formData.logo ? (
                    <img
                      src={URL.createObjectURL(formData.logo)}
                      alt="logo"
                      className="w-24 h-24 rounded-lg"
                    />
                  ) : (
                    <img
                      src="/Images/business/company/office-icon.png"
                      alt="logo"
                      className="w-24 h-24 rounded-lg"
                    />
                  )}
                </div>
                <p className="text-2xl font-bold text-gray-900 mb-2">
                  {formData.company_name !== ""
                    ? formData.company_name
                    : "Company Name"}
                </p>
                <p className="text-gray-700 mb-2 text-md">
                  {formData.tagline ? formData.tagline : "Tagline"}
                </p>
                <p className="text-gray-500 mb-4 text-md">
                  {formData.industry ? formData.industry : "Industry"}
                </p>

                <button className="bg-blue-600 text-white px-6 py-1 rounded-full flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    ></path>
                  </svg>
                  Follow
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyPage;
